import { createStore } from 'satcheljs';
var initialSurfaceActionsStore = {
    isAddinObserverLoaded: false,
};
var store = createStore('SurfaceActionsStore', initialSurfaceActionsStore)();
export default store;
//# sourceMappingURL=store.js.map